import React from 'react';
import { SyncMapsVehicleCardProps } from './hooks/use-sync-maps-vehicle-card-content';
import { SyncUpdateResponse } from '../../../services/sync-service/sync-map-service';

interface Props {
    hasCtr: boolean | undefined;
    ctrHide: boolean | undefined;
    hasSync: boolean | undefined;
    syncData: SyncUpdateResponse | null;
    vehicleCardContent: SyncMapsVehicleCardProps | null;
    cleanVersion: (version: string) => string;
    isSync5: boolean;
}

export const SyncMapsVehicleCardGeneration = (props: Props) => {
    return (
        <>
            {props.syncData?.generation &&
                ((props.hasCtr && !props.ctrHide) || props.hasSync) && (
                    <>
                        <p className="sync-maps-labels-row">
                            <span className="dark-text">
                                {props.isSync5 &&
                                props.vehicleCardContent
                                    ?.softwareGenerationLabel
                                    ? props.vehicleCardContent
                                          ?.softwareGenerationLabel
                                    : props.vehicleCardContent
                                          ?.syncGenerationLabel}
                            </span>
                            <span className="dark-gray-text">
                                {props.isSync5 &&
                                props.vehicleCardContent?.digitalExperienceLabel
                                    ? props.vehicleCardContent
                                          ?.digitalExperienceLabel
                                    : `${props.vehicleCardContent?.generationNumberLabel} ${props.syncData?.generation}`}
                            </span>
                        </p>
                        {props.syncData?.currentSyncVersion && (
                            <p className="sync-maps-labels-row">
                                <span className="dark-text">
                                    {props.vehicleCardContent?.syncVersionLabel}
                                </span>
                                <span className="dark-gray-text">
                                    {props.cleanVersion(
                                        props.syncData.currentSyncVersion
                                    )}
                                </span>
                            </p>
                        )}
                    </>
                )}
        </>
    );
};
